import { defaultAbsolutDepthsSettingsState } from '@/restore/global-settings/absolutDepths-settings';
import { defaultTabletSettings } from '@/store/well-logs/tabletSettings/index';
export const defaultLocalStorageMap = {
    absolutDepthsSettings: defaultAbsolutDepthsSettingsState,
    tabletSettings: defaultTabletSettings,
};
